import { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Books from "./pages/Books";
import Services from "./pages/Services";
import Rates from "./pages/Rates";
import Trainings from "./pages/Trainings";
import Faqs from "./pages/Faqs";
import Visit from "./pages/Visit";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Events from "./pages/Events";
import HowTo from "./pages/HowTo";
import AppAccess from "./pages/AppAccess";
import Portal from "./pages/Portal";
import AuthCallback from "./pages/AuthCallback";

import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Compose from "./pages/admin/Compose";
import BlogWriter from "./pages/admin/BlogWriter";
import Channels from "./pages/admin/Channels";
import BlogAdmin from "./pages/admin/BlogAdmin";
import EventsAdmin from "./pages/admin/EventsAdmin";
import TrainingsAdmin from "./pages/admin/TrainingsAdmin";
import MessagesAdmin from "./pages/admin/MessagesAdmin";
import Analytics from "./pages/admin/Analytics";
import AccessAdmin from "./pages/admin/AccessAdmin";
import ActivityAdmin from "./pages/admin/ActivityAdmin";
import { ADMIN_BASE } from "./config";

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash && !hash.includes("session_id=")) {
            const id = hash.replace("#", "");
            const scroll = () => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: "smooth" });
            };
            setTimeout(scroll, 120);
        } else if (!hash) {
            window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
        }
    }, [pathname, hash]);
    return null;
}

function AppRouter() {
    const location = useLocation();
    // Handle the Google OAuth return (session_id in URL fragment) before anything else.
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/books" element={<Books />} />
                <Route path="/services" element={<Services />} />
                <Route path="/rates" element={<Rates />} />
                <Route path="/trainings" element={<Trainings />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/visit" element={<Visit />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/events" element={<Events />} />
                <Route path="/how-to" element={<HowTo />} />
                <Route path="/app" element={<AppAccess />} />
            </Route>

            <Route path={ADMIN_BASE} element={<Portal />} />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <AdminLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="compose" element={<Compose />} />
                <Route path="ai-writer" element={<BlogWriter />} />
                <Route path="channels" element={<Channels />} />
                <Route path="blog" element={<BlogAdmin />} />
                <Route path="events" element={<EventsAdmin />} />
                <Route path="trainings" element={<TrainingsAdmin />} />
                <Route path="messages" element={<MessagesAdmin />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="access" element={<AccessAdmin />} />
                <Route path="activity" element={<ActivityAdmin />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ScrollManager />
                <AppRouter />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
